import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  image: '',
  title: '',
  status: '',
  search: '',
};
export const activityItemSlice = createSlice({
  name: 'review',
  initialState,
  reducers: {
    setItem: (state, action) => {
      const { name, value } = action.payload;
      state[name] = value;
    },
    setDefaultValue: (_, action) => {
      if (!action?.payload?.id) return initialState;
      return { ...action.payload };
    },
    resetData: () => {
      return initialState;
    },
  },
});
export const { setItem, setDefaultValue, resetData } = activityItemSlice.actions;

export default activityItemSlice.reducer;
